import React, { Component } from "react";
import { translate } from "../Services/translation";

class CookieConsent extends Component {
    constructor(props) {
        super(props);
        const cookie = this.getCookie("cookiesaccepted");
        this.state = { isVisible: !cookie };
        this.accept = this.accept.bind(this);
        this.setCookie = this.setCookie.bind(this);
        this.getCookie = this.getCookie.bind(this);
    }

    accept() {
        this.setState({
            isVisible: false
        });
        this.setCookie("cookiesaccepted", "true", 365);
    }

    setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === " ") c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    render() {
        if (!this.state.isVisible) {
            return null;
        }
        return (
            <div className="cookie-banner">                
                <div className="cookie-banner__text">
                    {translate("cookieconsent.text")} 
                    { window.__litium.cookiePageUrl && 
                        <a href={window.__litium.cookiePageUrl}>{translate("cookieconsent.readmore")}</a>
                    }
                </div>
                <div>
                    <a className="btn" onClick={this.accept}>
                        {translate("cookieconsent.accept")}
                    </a>
                </div>
            </div>
        );
    }
}

export default CookieConsent;
